import { ITagStatus } from './types';

export const CLEANER_BOT_TG_URL = process.env.CLEANER_BOT_TG_URL || 'https://t.me/realtycleaner_bot';
export const CLEANER_WEB_APP_URL = process.env.REACT_APP_CLEANER_WEB_APP_URL || 'https://cleaner.realtycalendar.ru';

export const ADMIN_SENTRY_DSN = process.env.REACT_APP_ADMIN_SENTRY_DSN;
export const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

export const RENTS_STATUSES = [
  {
    value: 'later',
    label: 'Потом заезжают',
  },
  {
    value: 'tomorrow',
    label: 'Завтра заезд',
  },
  {
    value: 'today',
    label: 'Сегодня заезд',
  },
  {
    value: 'live',
    label: 'Живут',
  },
  {
    value: 'leave',
    label: 'Сегодня выезд',
  },
  {
    value: 'out',
    label: 'Выехали',
  },
];

export const TIMES = [
  '9:00',
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
];

export const AUTOMESSAGES_NAMES: Record<string, string> = {
  automessage_today_comein: 'Напоминание о заселении',
  automessage_checkout: 'Напоминание о выезде',
  automessage_review_request: 'Запрос отзыва и новые брони',
  automessage_booked: 'Сообщение после получения брони',
  automessage_apartment_ready: 'Уведомление о готовности квартиры',
};

export const PAPERTRAIL_ENTITIES_NAMES: Record<string, string> = {
  cleaners: 'Горничные',
  ObjectCleaners: 'Объекты горничных',
  agencies: 'Агентства',
  objects: 'Объекты',
};

export const PAPERTRAIL_TYPE_NAMES: Record<string, string> = {
  created: 'Создан',
  updated: 'Обновлен',
  deleted: 'Удален',
};

export const DEFAULT_PAGE_LIMIT = 50;

export const HISTORY_NAMES: any = {
  visit: 'Гость посетил страницу',
  planin: 'Гость указал время приезда',
  passport: 'Гость прикрепил паспорт',
  passport_not_required: 'Паспорт не требуется',
  passport_declined: 'Паспорт отклонён',
  passport_accepted: 'Паспорт принят',
  addon_accepted: 'Дополнительная услуга принята',
  addon_declined: 'Дополнительная услуга отклонена',
  automessage_booked: 'Отправлено автосообщение',
  payment: 'Гость произвёл оплату',
  payment_declined: 'Оплата отклонена',
  payment_accepted: 'Оплата принята',
  in: 'Гость въехал',
  out: 'Гость выехал',
  key_show: 'Код кейбокса отправлен',
  key_hide: 'Код кейбокса скрыт',
  payment_info_show: 'Информация об оплатах открыта',
  payment_info_hide: 'Информация об оплатах скрыта',
  link_send: 'Ссылка отправлена гостю',
  client_get_deposit_link: 'Гость открыл оплату залога',
  automessage_today_comein: 'Отправлено автосообщение напоминание о заселении',
  automessage_checkout: 'Отправлено автосообщение напоминание о выезде',
  automessage_review_request: 'Отправлено автосообщение запрос отзыва',
  cleanrate: 'Гость оценил уборку',
  planin_admin: 'Менеджер указал время приезда',
  planout_admin: 'Менеджер указал время выезда',
  status_change_to_request: 'Изменение статуса на "Заявка"',
  status_change_to_booked: 'Изменение статуса на "Забронирован"',
  status_change_to_canceled: 'Изменение статуса на "Отменён"',
};

export const RENTS_ADDITIONAL_ACTION = {
  open_after_clean: 'Открывать сразу после уборки',
};

type HistoryRoleLabelsMap = {
  guest?: string;
  system?: string;
  manager?: (name?: string) => string;
};

const formatManagerLabel = (message: string, name?: string | null) => `Менеджер ${name ? `${name} ` : ''}${message}`;

export const HISTORY_NAMES_WITH_ROLES: Record<string, HistoryRoleLabelsMap> = {
  visit: {
    guest: 'Гость посетил страницу',
  },
  passport: {
    guest: 'Гость прикрепил паспорт',
    manager: (name) => formatManagerLabel('указал, что паспорт не нужен', name),
  },
  passport_not_required: {
    guest: 'Гость прикрепил паспорт',
    manager: (name) => formatManagerLabel('указал, что паспорт не нужен', name),
  },
  contract_not_required: {
    manager: (name) => formatManagerLabel('указал, что договор не нужен', name),
  },
  passport_declined: {
    manager: (name) => formatManagerLabel('отклонил паспорт', name),
  },
  passport_accepted: {
    manager: (name) => formatManagerLabel('принял паспорт', name),
  },
  automessage_booked: {
    guest: 'Отправлено автосообщение',
  },
  payment: {
    guest: 'Гость произвёл оплату',
  },
  payment_declined: {
    manager: (name) => formatManagerLabel('отклонил оплату', name),
  },
  payment_accepted: {
    manager: (name) => formatManagerLabel('принял оплату', name),
  },
  addon_accepted: {
    manager: (name) => formatManagerLabel('принял дополнительную услугу', name),
  },
  addon_declined: {
    manager: (name) => formatManagerLabel('отклонил дополнительную услугу', name),
  },
  receive_deposit: {
    system: 'Депозит оплачен',
  },
  return_deposit: {
    system: 'Возвращен залог',
    manager: (name) => formatManagerLabel('вернул залог', name),
  },
  return_deposit_fine: {
    system: 'Возвращен залог со штрафом',
    manager: (name) => formatManagerLabel('вернул залог с штрафом', name),
  },
  return_payment: {
    system: 'Возвращена оплата',
    manager: (name) => formatManagerLabel('вернул оплату', name),
  },
  return_payment_fine: {
    system: 'Возвращена оплата со штрафом',
    manager: (name) => formatManagerLabel('вернул оплату с штрафом', name),
  },
  manager_initiate_deposit_return: {
    manager: (name) => formatManagerLabel('нажал "Вернуть залог"', name),
  },
  in: {
    guest: 'Гость указал, что заехал',
    manager: (name) => formatManagerLabel('указал, что гость заехал', name),
  },
  out: {
    guest: 'Гость указал, что выехал',
    manager: (name) => formatManagerLabel('указал, что гость выехал', name),
    system: 'Система указала, что гость выехал',
  },
  out_canceled: {
    manager: (name) => formatManagerLabel('отменил выезд гостя', name),
    system: 'Выезд  гостя отменён',
  },
  key_show: {
    guest: 'Код кейбокса отправлен гостю',
    manager: (name) => formatManagerLabel('открыл код кейбокса гостю', name),
  },
  key_hide: {
    guest: 'Код кейбокса скрыт от гостя',
    manager: (name) => formatManagerLabel('скрыл код кейбокса гостю', name),
  },
  payment_info_show: {
    manager: (name) => formatManagerLabel('открыл информацию об оплатах', name),
  },
  payment_info_hide: {
    manager: (name) => formatManagerLabel('скрыл информацию об оплатах', name),
  },
  link_send: {
    guest: 'Ссылка отправлена гостю',
    manager: (name) => formatManagerLabel('отправил ссылку гостю', name),
  },
  client_get_deposit_link: {
    guest: 'Гость открыл оплату залога',
  },
  automessage_today_comein: {
    guest: 'Отправлено автосообщение напоминание о заселении',
  },
  automessage_checkout: {
    guest: 'Отправлено автосообщение напоминание о выезде',
  },
  automessage_review_request: {
    guest: 'Отправлено автосообщение запрос отзыва',
  },
  cleanrate: {
    guest: 'Гость оценил уборку',
  },
  cleanrate_accepted: {
    manager: (name?: string) => formatManagerLabel('подтвердил оценку уборки', name),
  },
  planin: {
    guest: 'Гость указал время приезда',
    manager: (name?: string) => formatManagerLabel('указал время приезда', name),
  },
  planout: {
    guest: 'Гость указал время выезда',
    manager: (name?: string) => formatManagerLabel('указал время выезда', name),
  },
  change_planin: {
    system: 'Изменилось планируемое время заезда',
  },
  change_planout: {
    system: 'Изменилось планируемое время выезда',
  },
  change_begin_date: {
    system: 'Изменилась дата заезда',
  },
  change_end_date: {
    system: 'Изменилась дата выезда',
  },
  change_rent_amount: {
    system: 'Изменилась сумма брони',
  },
  client_addons: {
    guest: 'Гость запросил допуслугу',
    // manager: "Менеджер указал время выезда",
  },
  deposit: {
    // guest: "Гость запросил допуслугу",
    manager: (name?: string) => formatManagerLabel('поменял сумму залога', name),
  },
  created: {
    system: 'Бронь создана',
  },
  status_change_to_request: {
    system: "Статус брони изменен на 'Заявка'",
  },
  status_change_to_booked: {
    system: "Статус брони изменен на 'Забронирован'",
  },
  status_change_to_canceled: {
    system: "Статус брони изменен на 'Отменена'",
  },
  guests_update: {
    guest: 'Гость указал количество',
  },
  object_changed: {
    system: 'Изменён объект брони',
    manager: (name) => formatManagerLabel('изменил объект брони', name),
  },
};

export const getLabelForHistoryName = (historyItem: any) => {
  const role: 'guest' | 'manager' | 'system' = historyItem.data?.role || 'guest';

  if (HISTORY_NAMES_WITH_ROLES[historyItem.name] === undefined) {
    return;
  }

  if (role === 'manager') {
    return HISTORY_NAMES_WITH_ROLES[historyItem.name][role]?.(historyItem.user?.name || historyItem.data?.manager_name);
  }

  return HISTORY_NAMES_WITH_ROLES[historyItem.name][role];
};

export const POINTS_SHOW = [
  {
    value: 'always',
    label: 'Всегда',
  },
  {
    value: 'today',
    label: 'В день заезда',
  },
  {
    value: 'comein',
    label: 'После заезда (гость попал в квартиру)',
  },
];

export const CLEANS_STATUSES: ITagStatus = {
  no: {
    label: 'не принята',
    color: 'orange',
  },
  accept: {
    label: 'принята',
    color: 'grey',
  },
  start: {
    label: 'в процессе',
    color: 'blue',
  },
  finish: {
    label: 'убрано',
    color: 'green',
  },
  finish_without_photo: {
    label: 'убрано (без фото)',
    color: 'orange',
  },
  refusal: {
    label: 'отказ',
    color: 'red',
  },
  deleted: {
    label: 'удалена',
    color: 'red',
  },
  canceled: {
    label: 'отменена',
    color: 'red',
  },
  canceled_manually: {
    label: 'отменена менеджером',
    color: 'red',
  },
};

export const CLEAN_OBJECT_STATES: ITagStatus = {
  good: {
    label: 'всё хорошо',
    color: 'green',
  },
  has_problems: {
    label: 'есть проблемы',
    color: 'orange',
  },
};

export const AUTOMESSAGE_STATUSES: ITagStatus = {
  pending: {
    label: 'Ожидает отправки',
    color: 'orange',
  },
  done: {
    label: 'Отправлено',
    color: 'orange',
  },
  sent_to_wappi: {
    label: 'Отправлено в Wappi',
    color: 'orange',
  },
  delivered: {
    label: 'Доставлено',
    color: 'green',
  },
  read: {
    label: 'Прочитано',
    color: 'green',
  },
  undelivered: {
    label: 'Не доставлено',
    color: 'red',
  },
  temporary_ban: {
    label: 'Временный бан',
    color: 'red',
  },
  error: {
    label: 'Ошибка',
    color: 'red',
  },
};

export const OBJECT_STATUSES: ITagStatus = {
  clean: {
    label: 'квартира убрана',
    color: 'green',
  },
  live: {
    label: 'живут в квартире',
    color: 'grey',
  },
  dirty: {
    label: 'выехали, уборка не начата',
    color: 'orange',
  },
  cleaning_now: {
    label: 'начата уборка',
    color: 'blue',
  },
};

export const CLEAN_ROLES_ICONS: any = {
  cleaner: '🧹',
  manager: '👔',
  guest: '🤵',
};

export const CLEAN_ROLES_TITLES: any = {
  cleaner: 'Горничная',
  manager: 'Менеджер',
  guest: 'Гость',
};

export const TASKS = [
  {
    value: 'passport',
    label: 'паспорт',
  },
  {
    value: 'payment',
    label: 'оплата',
  },
  {
    value: 'deposit',
    label: 'залог',
  },
  {
    value: 'phone',
    label: 'нет телефона',
  },
  {
    value: 'link',
    label: 'ссылка',
  },
  {
    value: 'automessage_error',
    label: 'автосообщение не доставлено',
  },
  {
    value: 'plan_out_missing',
    label: 'время выезда',
  },
  {
    value: 'no_cleans',
    label: 'нет уборки',
  },
];

export const SHOW_HOWIN_OFFSET_MINUTES = [
  0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 180, 240, 300, 360, 420,
];
export const SHOW_KEYBOX_OFFSET_MINUES = SHOW_HOWIN_OFFSET_MINUTES;
export const HIDE_KEYBOX_OFFSET_MINUTES = [0, 15, 30, 60, 120, 180, 240];

export const AUTOMESSAGE_REMINDER_TIME_HOURS = [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];

export const formattedMessengerName = (messenger: any) => {
  switch (messenger) {
    case 'whatsapp':
      return 'WhatsApp';
    case 'max':
      return 'MAX';
    default:
      return '';
  }
};
